
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4d149a5f&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Precos.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Precos.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-4d149a5f!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Precos.vue"),
  /* scopeId */
  "data-v-4d149a5f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Precos.vue
// module id = 80
// module chunks = 0